var $f8e62fab04776d30$exports = {};
$f8e62fab04776d30$exports = {
    "collectionLabel": `\u{41F}\u{440}\u{435}\u{434}\u{43B}\u{43E}\u{436}\u{435}\u{43D}\u{438}\u{44F}`
};


export {$f8e62fab04776d30$exports as default};
//# sourceMappingURL=ru-RU.mjs.map
